export const invoiceChartColors = [
  '#1C4B74', // Blue shade from gradient
  '#117964', // Teal shade from gradient
  '#0D5E4F', // Darker teal
  '#1A5D7F', // Medium blue
  '#0A4A3E', // Deep teal
];

